/**
 * Customer Configuration File
 * 
 * In a customer-specific clone/fork, customize this file and files in `client/src/custom/`.
 * Core engine files outside `client/src/custom/` should NOT be modified directly, ensuring
 * seamless, conflict-free inheritance of future core updates via `npm run core:sync`.
 */

export const customerConfig = {
  // Unique customer identifier & business name
  id: "default",
  name: "Books & Inventory PWA",
  shortName: "BooksApp",
  tagline: "Mobile-First Business Billing & Inventory Management",

  // Visual Branding & Theme
  branding: {
    appLogo: "📚", // Emoji or URL to SVG/PNG in public/
    theme: "dark",  // Default theme: 'dark' | 'light' | 'auto'
    primaryColor: "#2563eb",
    accentColor: "#38bdf8"
  },

  // Module Feature Flags
  // Toggle off any features this customer does not require
  features: {
    dashboard: true,
    invoices: true,      // Sales invoices & estimates
    purchases: true,     // Vendor purchases & expense tracking
    inventory: true,     // Stock movements & low stock alerts
    items: true,         // Goods & services master catalog
    customers: true,     // Customers & vendor directory
    gstReports: true,    // Monthly GSTR-1 & sales breakdown reports
    companies: true,     // Multi-branch / multi-company management
    backupGoogleDrive: true // Cloud backup export
  },

  // Regional & Business Defaults
  businessDefaults: {
    currency: "INR",
    currencySymbol: "₹",
    country: "IN",
    defaultState: "Tamil Nadu",
    defaultStateCode: "33",
    taxSystem: "GST", // 'GST' | 'VAT' | 'NONE'
    defaultInvoicePrefix: "",
    defaultNonGstPrefix: "",
    defaultInvoiceCopies: 2,
    defaultInvoiceTemplate: "paper-ledger", // 'paper-ledger' | 'modern-tax' | 'compact' | custom ID
    dateFormat: "DD-MM-YYYY"
  },

  // Authentication Settings
  auth: {
    allowedEmailDomain: "webs8.com", // Default login domain for simplified username-only entry
    allowUserRegistration: true,
    defaultRole: "billing"
  }
};

export default customerConfig;
